import { render, staticRenderFns } from "./MobileViewsSlider.vue?vue&type=template&id=00bdc8cd&scoped=true"
import script from "./MobileViewsSlider.vue?vue&type=script&lang=js"
export * from "./MobileViewsSlider.vue?vue&type=script&lang=js"
import style0 from "./MobileViewsSlider.vue?vue&type=style&index=0&id=00bdc8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdc8cd",
  null
  
)

export default component.exports